<template>
  <LayoutDefault :title="$t('review_observation.listagem.titulo_pagina')">
    <ReviewObservationFilter @search="search"/>
    <b-card v-if="reviewObservations.length > 0 || loading" body-class="p-0" class="mt-3 d-flex flex-column p-0">
      <ReviewObservationTable class="flex-fill"
             :isLoading="loading"
             :items="reviewObservations"
             @click-reviewObservation="openEdit"
             @cancel-reviewObservation="cancelResults"
             ref="reviewDataTable"/>
      <Paginator v-if="paginator.total > paginator.per_page"
                 :page="paginator.page"
                 :per-page="paginator.per_page"
                 :total="paginator.total"
                 @change="paginate"/>
    </b-card>
    <EmptyData v-else title=" "/>
  </LayoutDefault>
</template>

<script>
import CountDown from "@/components/CountDown";
import EmptyData from "@/components/EmptyData";
import Paginator from "@/components/Paginator";
import LayoutDefault from "@/templates/LayoutDefault";
import {mapActions, mapGetters} from 'vuex';
import ReviewObservationFilter from "./ReviewObservationFilter";
import ReviewObservationTable from "./ReviewObservationTable";
import ReviewObservationRepository from '@/repositories/ReviewObservationRepository'
import $axios from '@/providers/AxiosServiceProvider'
import HttpStatus from 'http-status-codes'

export default {
  name: "Observation",
  components: {
    ReviewObservationFilter,
    EmptyData,
    ReviewObservationTable,
    CountDown,
    Paginator,
    LayoutDefault
  },
  computed: {
    ...mapGetters({
      reviewObservations: 'reviewObservation/all',
      reviewObservation: 'reviewObservation/current',
      loading: 'reviewObservation/isLoading',
      paginator: 'reviewObservation/pagination',
      filtro: 'reviewObservationFilter/all'
    }),
  },
  methods: {
    ...mapActions([
      'reviewObservation/listAll',
      'reviewObservation/listOne',
      'reviewObservation/listOrders',
      'reviewObservation/listReports',
      'reviewObservation/listReportsByVnsId',
      'reviewObservation/listOrdersByVnsId',
      'reviewObservationFilter/setSpecific',
      'reviewObservationFilter/reset',
    ]),
    search() {
      this.$store.commit(
          'reviewObservation/setPagination',
          {
            page: this.paginator.page,
            per_page: this.paginator.per_page
          },
          {root: true}
      );

      let customFilter = {};
      if (this.filtro.vns_filter) {
        customFilter["vns.name"] = this.filtro.vns_filter;
      }
      if (this.filtro.container_filter) {
        customFilter["integration_containers.identifier"] = this.filtro.container_filter;
      }
      if (this.filtro.patient_filter) {
        customFilter["integration.patients.name"] = this.filtro.patient_filter;
      }

      let filters = {
        page: this.paginator.page,
        per_page: this.paginator.per_page
      };

      if (Object.keys(customFilter).length > 0) {
        const filtersArray = Object.entries(customFilter).map(([k, v]) => {
          return `["${k}","LIKE","%${v}%"]`;
        });

        filters = {        
          'filters': filtersArray,
          ...filters
        };
      }

      this.$store.commit('reviewObservation/setAll', [], {root: true})
      this['reviewObservation/listAll'](filters)
    },
    paginate(pagination) {
      this.$store.commit('reviewObservation/setPagination', pagination, {root: true})
      this.search()
    },
    async openEdit(item) {
      this.$router.push({name: 'review_observation.edit', params: {id: item.id}});
    },
    async cancelResults(item) {
      const vm = this
      this.$snotify.clear()
      this.$snotify.confirm(          
          this.$t('review_observation.listagem.confirmacao_cancelamento.mensagem'),
          this.$t('review_observation.listagem.confirmacao_cancelamento.titulo'),
          {
            showProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            buttons: [
              {
                text: 'Sim',
                bold: true,
                action: toast => {
                  this.$snotify.remove(toast.id)
                  $axios.put(`integration/review_observation/cancel/${item.id}`).then(response => {                  
                    if (response.data.status === 'success') {
                      this.$snotify.warning(this.$t('review_observation.form.cancel.success'), {timeout: 8000})                      
                      vm.loadData()
                    } else {
                      this.$snotify.error(this.$t('review_observation.form.cancel.error'), {timeout: 8000})
                      if (error.response.status === 422) {
                        ReviewObservationRepository.toastValidationErrors(error, this.$snotify)
                      }
                    }
                  })
                }
              },
              {
                text: 'Não',
                action: toast => {
                  this.$snotify.remove(toast.id)
                },
                bold: true
              }
            ]
          }
      )
    },
    loadData() {
      this['reviewObservationFilter/setSpecific']({show: false})
      this['reviewObservationFilter/reset']()
      this.paginate({page: 1, per_page: 10, total: 0})
    }
  },
  mounted() {
    this['reviewObservationFilter/setSpecific']({show: false})
    this['reviewObservationFilter/reset']()
    this.paginate({page: 1, per_page: 10, total: 0})
  }
}
</script>

<style lang="scss">
.mx-datepicker-range,
.mx-datepicker {
  width: 100% !important;
}
.snotify-confirm {
  max-width: 800px !important;
  width: auto !important;
  min-width: 420px !important;
  white-space: normal !important;
}

.snotify-rightTop {
  right: 150px !important;
  top: 20px !important;
}
</style>
